import { request } from "../http";

export default {
    // 获取首页信息
    getMainPageInfo(params) {
        return request('post', '/sd_smi/api/v1/Web_MainPage/getMainPageInfo', params, 'json', { takeGuest: true });
    },

    // 获取首页banner
    getMainPageBanner(params) {
        return request('post', '/sd_smi/api/v1/Web_MainPage/getMainPageBanner', params, 'json', { takeGuest: true });
    },

    // 获取电话区号
    getTelephoneAreaCodeList(params) {
        return request('post', '/sd_smi/api/v1/Sys_Public/getTelephoneAreaCodeList', params, 'json', { takeGuest: false });
    },

    // 获取数据中心列表
    getDateCenterList(params) {
        return request('post', '/sd_smi/api/v1/Sys_Public/getDateCenterList', params, 'json', { takeGuest: false });
    },

    // 获取国家/省/城市
    getLocationList(params) {
        return request('post', '/sd_smi/api/v1/Sys_Public/getLocationList', params, 'json', { takeGuest: false });
    },

    getCountryList(params) {
        return request('post', '/sd_smi/api/v1/Sys_Public/getLocationListNew', params, 'json', { takeGuest: false });
    },

    // 获取省列表
    getStateList(params) {
        return request('post', '/sd_smi/api/v1/Sys_Public/getStateList', params, 'json', { takeGuest: false });
    },

    // 获取城市列表
    getCityList(params){
        return request('post', '/sd_smi/api/v1/Sys_Public/getCityList', params, 'json', { takeGuest: false });
    },

    // 获取搜索关键字
    getSearchHotwordList(params = {}) {
        return request('post', '/sd_smi/api/v1/Web_Guest/getSearchHotwordList', {...params, platformType: "2"}, 'json');
    },

    // 图片上传
    uploadImg(params) {
        // return request('post', 'http://10.86.130.31:30280/uploadaws', params, 'json');
        return request('post', '/blade-system/file/upload', params, 'json');
    },
    // uploadImg(params) {
    //     return request('post', 'https://service-ext.kedaceramics.com/uploadaws', params, 'json');
    // },
    getLocationDetail(params) {
        return request('get', `https://maps.google.com/maps/api/geocode/json?latlng=${params.latlng}&language=zh-CN&sensor=true&key=${params.key}`, {})
    },

    // 获取指定国家所有城市
    getAllCity(params) {
        return request('post', '/sd_smi/api/v1/Sys_Public/getAllCity', params, 'json');
    },

    // 获取客服信息
    getCustomerServiceInfo(params) {
        return request('post', '/sd_smi/api/v1/Web_User/getCustomerServiceInfo', params, 'json', { takeGuest: true, noMessage: true });
    },

    // 获取隐私政策
    getPrivacyPolicy(params) {
        return request('post', '/sd_smi/api/v1/Sys_Public/getPrivacyPolicy', params, 'json', { takeGuest: true });
    },

    // 获取服务协议
    getServiceRules(params) {
        return request('post', '/sd_smi/api/v1/Sys_Public/getServiceRules', params, 'json', { takeGuest: true });
    },

    // 获取广告
    getAD(params) {
        return request('post', `/sd_smi/api/v1/Sys_Public/getAD?type=${params.type}&bannerType=${params.bannerType}`, {}, 'json', { takeGuest: true });
    },
    // 分享链接埋点
    shareTouchRecord(params) {
        return request('post', '/sd_smi/api/behavior/share-touch/record', params, 'json');
    }
}



// WEBPACK FOOTER //
// ./src/request/apis/common.js